var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.096,
    height: 17.227,
    viewBox: "0 0 17.096 17.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #009ab2;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-miterlimit: 10;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_message-circle",
    "data-name": "icon / message-circle",
    transform: "translate(-7.404 0.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-2",
    d: "M5.881,4.654a1.684,1.684,0,0,0,0-2.379L4.1.493a1.682,1.682,0,0,0-2.379,0l-.978.979A2.519,2.519,0,0,0,.42,4.646,39.111,39.111,0,0,0,11.354,15.58a2.523,2.523,0,0,0,3.175-.318l.978-.979a1.681,1.681,0,0,0,0-2.379L13.723,10.12a1.681,1.681,0,0,0-2.379,0l-.595.595A39.912,39.912,0,0,1,5.286,5.25Z",
    transform: "translate(0 0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCall);
export default __webpack_public_path__ + "static/media/icon-call.4c86f01ebc2c4f3ae08e3efdebcd2dac.svg";
export { ForwardRef as ReactComponent };